module.exports = __webpack_public_path__ + "img/1.40e0bfe6.png";